import * as React from 'react';
/**
 *
 * Original name: eraser
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=35735%3A9690
 *
 */
export const EraserLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.341 17.254.616.616 6.589-6.59-6.984-6.983-6.589 6.59.61.61L3.62 13.46a2.223 2.223 0 0 0 0 3.144l2.397 2.397h3.59l1.734-1.747Zm-6.66-2.734 1.963-1.963 3.637 3.637L8.982 17.5H6.638l-1.957-1.958a.723.723 0 0 1 0-1.023Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M20 19h-7.279l1.75-1.5H20V19Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
